import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {createRoot} from 'react-dom/client';
import * as lucide from 'lucide';
import {Money} from './components/Money.jsx';
import './theme.js';
import './demo/money.js';
import {configurePreview} from './configuration.js';
import * as priceRules from './price-rules.js';
import * as backofficePreview from './backoffice-preview.js';

window.React = React;
window.ReactDOM = {...ReactDOM, createRoot};
window.lucide = lucide;
window.ZalsoDesignSystem_d9d781 = {Money};
configurePreview();
window.ZalsoBackofficeNotice=text=>{window.__boNotice=text;window.dispatchEvent(new CustomEvent('zalso:preview-notice',{detail:text}));};
window.ZalsoBackofficePreview=backofficePreview;
window.ZalsoBackofficeStorage=window.ZalsoBackofficeStorage||backofficePreview.createScopedStorage(localStorage,window.__BIZ+'.'+(window.DAY1?'day1':'running'),window.ZalsoBackofficeNotice);
window.ZalsoBackofficeSource=window.ZalsoBackofficeSource||backofficePreview.createPreviewSource(window.ZalsoBackofficeStorage,window.ZalsoBackofficeNotice);
window.ZalsoPriceRulePreview = priceRules;
window.ZalsoPriceRuleSource = window.ZalsoPriceRuleSource || priceRules.createPriceRuleSource(localStorage, window.DAY1);
// Only the local preview server implements this. No production device or backend API.
window.ZalsoPreview = {
  async openRegister(business) {
    const response = await fetch('/preview/native/tablet', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({business})});
    if(!response.ok) throw new Error(await response.text());
  }
};
